import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    menu: 1,
    first: null
  },
  mutations: {
    setMeun(state, current) {
      // console.log(current);
      state.menu = current;
    },
  },
  actions: {
  },
  modules: {
  }
})
